import React, { Component } from 'react'
import styled from 'styled-components'

const ImageElt = styled.img`
  width: 100%;
  max-height: 50vh;
  display: block;
  object-fit: contain;
  object-position: center;
`

export default class Image extends Component {
  render() {
    return <ImageElt alt="" {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Image.js